<template>
  <div class="ca-home-container">
    <div class="swipe-container" style="height: 225px;">
      <div class="location-search">
        <van-icon name="location-o" color="#fff" size="18" />
        <span style="font-size: 14px; color: #fff; margin-right: 10px;">上海</span>
        <van-search v-model="value" placeholder="搜索内容" background="transparent" />
      </div>
      <van-swipe :autoplay="3000" style="height: 100%;">
        <van-swipe-item v-for="(image, index) in images" :key="index">
          <img :src="image" style="width: 100vw; height: 225px;"/>
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="nav-container">
      <div class="nav-item" v-for="item in navList" :key="item.url">
        <img :src="item.url">
        <span>{{ item.text }}</span>
      </div>
    </div>
    <div class="notice-container">
      <van-notice-bar left-icon="volume-o" text="金企贷佣金上调至0.40%。"/>
    </div>
    <div class="product-container">
      <div class="title">推荐产品</div>
      <div class="product-list">
        <div class="product-item" v-for="item in products" :key="item.icon">
          <img class="icon" :src="item.icon"/>
          <div class="content">
            <div class="name">{{ item.name }}</div>
            <div class="good">
              <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAWCAYAAAChWZ5EAAAAAXNSR0IArs4c6QAABRtJREFUSEudlWtsFFUUx//n7uxStgt9l4elfMBSqwkaAyi0nd0+trRRBKGlBKJA5JE0fiGGqIBGxUc0xmgQHxQiEHn1gQhK7QMy223FigQJpkEEH7EQ+1rog9Lt7p1jZkqbFlpdOl9m5t7z/9/fPefcGcIYL66ZEANWygCaClhXkbv5h7FY0VhEhoZPRhdARwnAAEQludtzx+I1doBKRzyE9RhAkyGwnrJ8VaECcFVEFixKCrztnxBXxy+FDKyDxVpM7pbyUE3GGsenYpMh9Yswts68k7gmhiF1wEpAm0+hZZChmHNVXBJIvgxCJBgV5PYVh6Q7PyEZt+giOhVAYBexJ2I3HPJZSHxMc7s3hmRSHRUBpiYQHDC2wgxYsImyfO+Hom/9NnZmbEJPNgI9xWYPXDs+1T5l4bVbhlUoBlwT9TmY1oNRD5LnAUuRqVMsUyij9Z//8pj9QK4rMaL38pEGrcmIMwGefCwzp6XTsjNugjwjZPiq42eP94xmwifiZ8AavGzOc3Am5XT+xjVRV8HGcaRj5G5fNJo23+X6TEBu6OpR0NGtPPN9Y/WXJsDCec728TY9Wmfz9Q8r85qDXq9nJCOujvoOoAUgOkXZ7VkmR010rtEH/eWQLsq5MUxbkJqaCIvlAAOpA56s67vL6+rWmivmO50Hwbx8cNJIja6/VlZX9/pQCK6Mng8L6s1KkfV+ymq5MqipjKmGQDag/07u6zMGxgvV+TkSymEAkf1Z66+ycDjSSioq6k2AAlXNZOAkgA4AP4LZDTKnPG2dYrX2s/anqdUif0FAPATGXsrxrR4GVx2VCNBfEAAi+opodven6bPcmydF+t8y44jOgtkAXgbmy2Veb9JgD5hZUNVmADEgytCZpwlgvzHeF6SePj8tOLi1MTYyqfsrXA3TYZexlN5x/c4S8Tn7m7DxlkCTvXXVuw+ebu9UnppolyDmw6Ve7/IlqqoJwCmItpR4PG8PB0hN/YAUZaMOfFPu8Sw0s0K0j8D3tVy3IneOT7609ooF9uA6erhn12iNdn5vwqXi8oSkxr/tiJkYBIHeK/F4XnxaVVMsQKOh04WYdkQbcgqMwcUu1yNWXT9nPEu/f9qRhoamFWlpUX3MX0BRFl1tsyE1uUOflBhI2/ThudMjAaTPysq32/BRQPLUSVEBGdSxvFTzlhmxS1V1PwErCKgtra11DuiH/QuWquqvBMwMMm8+6vW+MxC0TE3bqljEttbOMHR168HoCLnbbgs0CICYSNeBMCHEAil5cVASHOPlBVuYXLnnxOkLhkdeXt648Js32wSRQxCtOaRpe0YEyE9PfwVEbxDRpVKPJ3noLpc8Pie7j2y77OOs03Vjyf7G6r/f7mwzvTr2+RTxnKZpwQF9gaoWguhQUMpeRVHiSjWte0SAwszMGTLY/5FhKeeU19f/NBRiXkLC+KSUlI09fv8TAOKZ2UAgEPUy0SWLru8t8XqP3lmefFU9EWaz5bV0dByoOnNm5dD5u37HS9LSGixCzNWBneW1tRtGa7ZQx80+EqLd/OoyZ5d5vcZxH7zuAijMyCiSweAOCNFV5vFMDHWh0eLync4iMO8A0FxWWzv5zri7AAxiP5GP+uv7iUOIF/ZoWu9YQAqcznnM/DWY44QQr5Z4PNv+F8A8Mi7X86Tr228H3wBRM5it9wAhwWwD0XSzV4HGyeHhj26vqPCHBGAEFTid61nXNw+Y3MPiw+obAA7rUq47Vl/fNZLHv4AuElLzhg+VAAAAAElFTkSuQmCC" alt="">
              {{ item.good }}
            </div>
            <div class="tips">
              <div class="tip" v-for="tip in item.tips" :key="tip">
                <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAYAAADgKtSgAAAAAXNSR0IArs4c6QAABBdJREFUSEuVlV1oW2UYx//Pez6SNqVd87F2bijCnIpFCs4pwq6KVUfV2a2VdXTq2iSz4tTNDxBlYZdFRR1bmqSiYRTXll3M1a5D8WIIUtC6DefHEPGmrDVJg12bnpyc8z6SbKldP9LuXJyLl//ze5/3fZ/n/xDW8NW+kn3AsvAgYG8EwQYrE6zgYuqE/jtAvBKCSrG9weweZnlICH2rlNZNaT6EIYQCW9qXVcbRf2KO08txloV7g+ZWZnwJ8GYiMW5amX5NOL9n4CqrUITE3bZtNKjCuRuEDcz4TQjam+jRf164yRK4J2juA3OcwEmbsS8dc4yUOnrFC9auMqc8Lpl9gtCWiOgDRf0tcK/feIaJzhDJASXj3D95kmbX8CRwv8qVImueAugpltSQ6tW+y8fNw6sPZOuExBiTGJqKaM1rgd6iCbHwjZtnJKGJFL4vGXb+MQ/3BswfSchNiR5n7W2BA6x5xNz6VE/5eHWAqxTKXWWJX1OkNRbgvs7cdhbyQmZWeTrTpw7dDtwXzJ6WjOZU1FFgufbmGstc8jzb9EhhwRM0Rpjo3qkKvQ4frO2esZkdNY9bJy1btoDom1REbywm5X7ZnCbL7qbal9iX08xLUsFoOux4bq1ZV+00+9RatLHkrytNffffX5BRjK3qMnoVC/eQ129sYcJFSeJQOqL3zMMDrCFKuaWbMa1/2+jjHO3hGTqXjDl2LNZ4A2aAId8iX5dZLy0ey5HSNB1Rh/NCtz/3GJH8lonfm9rg+BghkgVAiFXPhBmHRBszhhVNfz5xgmYWwz0d1k6oVoQ8Xdn7YfElJrV9KqL254Xe/XwHq+YPAO4UTMcSMf1gYT2QPcrA+8QYTsb0ppWay+O32pmsEK3rmLtLUcSYlFZ/utfVVcyipp1dufLsOWLaTsCgFDRCkj8D8FW1Q2/98xhlV3qf6s6ZbqHoD92oloB5WcqcSPe66hYG+Lq4QlpmnAnNxAXDGk1FHY+u9ujrOmd+UUgbKsDdfuM1IcRHGUPblonTT4uDazqsqKXYO0zo9dejlCwFd3VyTblqTRDw5MIOzdhM59MxbWk5hljgCgiDZK+WdbXfvKAQNjo0bds83B3ItgiiAbB8Mxl1frgaZNkSPWAekYwjzPRiKqrH/3fFFlbc7lyYmDtUJv9kTPu8lNUuhvsCxkEJ+gSCw6keZ6Ewlvi5N5jtZ6CVmHrlrHZ4qo+mS52isoPdDs0MS4lWAcQTaT2AQTKXhSPEwnPNehcsQwzMCaaYWYFTZUntStHfN73BZf+yVa/PymcZdJiIVUC8k4pq3QsTWXGGFmxB0KdgPHFjauZ/NzuVWBTXiHBWEfz6ZNj51+ITlhzQeXHeo4U0G6DiYWbeIgCFJa4JiFFDN85eP16ZWuna/gO8F8/JjojHywAAAABJRU5ErkJggg==" alt="">
                {{ tip }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <van-tabbar v-model="active" active-color="#f1303d" inactive-color="#000" @change="onChangeTab">
      <van-tabbar-item name="home" icon="home-o">首页</van-tabbar-item>
      <van-tabbar-item name="products" icon="apps-o">产品中心</van-tabbar-item>
      <van-tabbar-item name="my" icon="friends-o">我的</van-tabbar-item>
    </van-tabbar> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      images: [
        'http://www.szwbl.cn/public//uploads/20230408/8f3a268bf2fe7760973814d0cf4ea349.jpg',
        'http://www.szwbl.cn/public//uploads/20220723/507d2fe39b92d8dc2b97df65b003e464.jpg',
      ],
      navList: [{
        text: '招聘团队',
        url: 'http://www.szwbl.cn/public//uploads/20230408/f3ebb3ae57e671c8986c1df3384e55b1.jpg'
      }, {
        text: '一键推广',
        url: 'http://www.szwbl.cn/public//uploads/20230408/eb51d7a573dec0842d7890cd56bf8bbe.jpg'
      }, {
        text: '进度查询',
        url: 'http://www.szwbl.cn/public//uploads/20230408/bb80973d1c6e3a9c373e7ef7ac355ca7.jpg'
      }, {
        text: '贷款计算器',
        url: 'http://www.szwbl.cn/public//uploads/20230408/ea878e50c0e2fb930160efca6bc065bb.jpg'
      }, {
        text: '智能匹配',
        url: 'http://www.szwbl.cn/public//uploads/20230408/fb790be6a178ef2a50dc1f5b4c679e49.jpg'
      }, {
        text: '发圈素材',
        url: 'http://www.szwbl.cn/public//uploads/20230408/c1a528c65509055cb687ce9b26e146f1.jpg'
      }, {
        text: '佣金政策',
        url: 'http://www.szwbl.cn/public//uploads/20230408/eb87baa15bb7c5323502fecf17bc3ac7.jpg'
      }, {
        text: '在线采票',
        url: 'http://www.szwbl.cn/public//uploads/20230408/880b505b5b7aa1061cc5ace38fad2a94.jpg'
      }, {
        text: '产品大纲',
        url: 'http://www.szwbl.cn/public//uploads/20230408/30e30e8a9c523c21c88b38f964e4710d.jpg'
      }, {
        text: '税局查询',
        url: 'http://www.szwbl.cn/public//uploads/20230408/9157dc4429a8285116c86de1037b972a.jpg'
      }],
      products: [{
        icon: 'http://www.szwbl.cn/public//uploads/20220819/291ef03323fb907c46cd7ed209848524.jpg',
        name: '中信银行—信秒贷',
        good: '公积金，按揭房客户好批！',
        tips: [
          '最高额度30W',
          '年化利率4.35%-15.36%',
          '先息后本，等额本息',
          '周期12期'
        ],
      }, {
        icon: 'http://www.szwbl.cn/public//uploads/20240605/2b935eaee6a00e6cf3ed2a7456efe484.jpg',
        name: '商E借流水贷',
        good: '包负债能力强！',
        tips: [
          '最高额度50W',
          '月费率0.62%起',
          '等额本息，优质客户可以先息后本',
          '周期6期/9期/12期'
        ],
      }, {
        icon: 'http://www.szwbl.cn/public//uploads/20221016/1948d5fd8e367d3f004c72c54cce049e.jpg',
        name: '众邦银行-众商贷（企业版）',
        good: '件均高达150万！',
        tips: [
          '最高额度300W',
          '年化利率年化7.5%-15%',
          '等额本息',
          '周期3期/6期/9期/12期'
        ],
      }, {
        icon: 'http://www.szwbl.cn/public//uploads/20220831/89c0b6c5dba8f508c707c3f95b29befe.jpg',
        name: '浦发银行-浦慧税贷',
        good: '断票要求宽松！',
        tips: [
          '最高额度300W',
          '年化利率年化6.18%-9.79%',
          '等额本息，等额本金',
          '周期3期/6期/12期'
        ],
      }]
    };
  },
  methods: {
    onChangeTab(name) {
      const hasLogin = localStorage.getItem('has_login')
      if (hasLogin) {
        this.$router.replace(`/ca/${name}`)
      } else {
        this.$router.replace(`/ca/login`)
      }
    }
  },
};
</script>
<style lang="less">
.ca-home-container {
  min-height: 100vh;
  // padding-bottom: 50px;
  background-color: #f5f5f5;
  .swipe-container {
    .location-search {
      position: fixed;
      left: 0;
      top: 0;
      z-index: 5;
      width: 100%;
      display: flex;
      align-items: center;
      padding: 10px;
      .van-search {
        padding: 0;
        flex: 1;
        .van-search__content {
          border-radius: 6px;
        }
      }
    }
  }
  .nav-container {
    width: 100%;
    padding: 10px 5px;
    background-color: #fff;
    display: flex;
    flex-wrap: wrap;
    .nav-item {
      width: 20%;
      display: flex;
      flex-direction: column;
      margin-bottom: 10px;
      align-items: center;
      img {
        width: 40px;
        height: 40px;
      }
      span {
        margin-top: 5px;
        font-size: 12px;
        font-weight: 400;
        color: #4b4b4b;
        text-align: center;
        letter-spacing: 1px;
      }
    }
  }
  .product-container {
    margin-top: 10px;
    width: 100%;
    padding: 10px 15px 0 15px;
    background-color: #fff;
    .title {
      font-size: 16px;
      font-weight: 700;
      color: #2655f9;
    }
    .product-list {
      margin-top: 12px;
      .product-item {
        display: flex;
        padding: 15px;
        background-color: #fff;
        border-bottom: 0.5px solid #f6f7f9;
        .icon {
          width: 58px;
          height: 58px;
          margin-right: 10px;
        }
        .content {
          display: flex;
          flex-direction: column;
          .name {
            font-size: 15px;
            line-height: 1.8;
            font-weight: 700;
            color: #000;
          }
          .good {
            font-size: 12px;
            line-height: 1.8;
            font-weight: 700;
            color: #ff7b00;
            img {
              width: 16px;
              height: 11px;
              margin-right: 5px;
            }
          }
          .tips {
            .tip {
              font-size: 12px;
              font-weight: 400;
              color: #666;
              img {
                width: 12px;
                height: 12px;
              }
            }
          }
        }
      }
    }
  }
}
</style>